var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "fixed-grid has-12-cols" }, [
    _vm.value && _vm.customer && _vm.vehicle
      ? _c(
          "div",
          { staticClass: "grid is-col-min-15" },
          [
            _c(
              "div",
              {
                staticClass: "cell is-flex pr-0",
                class: {
                  "is-col-span-12": _vm.editMaximize,
                  "is-col-span-6": _vm.isEmail && !_vm.editMaximize,
                  "is-col-span-7": !_vm.isEmail && !_vm.editMaximize,
                },
              },
              [
                _c("div", { staticClass: "is-flex-grow-1 is-flex" }, [
                  _c(
                    "article",
                    {
                      staticClass:
                        "box detail-page-tile is-flex-grow-1 is-flex is-flex-direction-column",
                    },
                    [
                      _c("p", { staticClass: "title" }, [_vm._v("Message")]),
                      _c("div", { staticClass: "tabs" }, [
                        _c("ul", { staticStyle: { "margin-top": "5px" } }, [
                          _c(
                            "li",
                            {
                              class: {
                                "is-active": _vm.activeTab == "SMS",
                                "tab-disabled":
                                  _vm.activeTab !== "SMS" && _vm.editMaximize,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setActiveTab("SMS")
                                },
                              },
                            },
                            [
                              _c("a", [
                                _c("span", [
                                  _vm._m(0),
                                  _c("span", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.smsUnreadCount,
                                        expression: "smsUnreadCount",
                                      },
                                    ],
                                    staticClass:
                                      "has-badge-info has-badge-rounded has-badge-medium",
                                    attrs: { "data-badge": _vm.smsUnreadCount },
                                  }),
                                ]),
                              ]),
                            ]
                          ),
                          _vm.isShowWhatsApp
                            ? _c(
                                "li",
                                {
                                  class: {
                                    "is-active": _vm.activeTab == "WhatsApp",
                                    "tab-disabled":
                                      _vm.activeTab !== "WhatsApp" &&
                                      _vm.editMaximize,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setActiveTab("WhatsApp")
                                    },
                                  },
                                },
                                [
                                  _c("a", [
                                    _c("span", [
                                      _vm._m(1),
                                      _c("span", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.whatsappUnreadCount,
                                            expression: "whatsappUnreadCount",
                                          },
                                        ],
                                        staticClass:
                                          "has-badge-info has-badge-rounded has-badge-medium",
                                        attrs: {
                                          "data-badge": _vm.whatsappUnreadCount,
                                        },
                                      }),
                                    ]),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "li",
                            {
                              class: {
                                "is-active": _vm.activeTab == "Email",
                                "tab-disabled":
                                  _vm.activeTab !== "Email" && _vm.editMaximize,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setActiveTab("Email")
                                },
                              },
                            },
                            [
                              _c("a", [
                                _c("span", [
                                  _vm._m(2),
                                  _c("span", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.emailUnreadCount,
                                        expression: "emailUnreadCount",
                                      },
                                    ],
                                    staticClass:
                                      "has-badge-info has-badge-rounded has-badge-medium",
                                    attrs: {
                                      "data-badge": _vm.emailUnreadCount,
                                    },
                                  }),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "is-flex-grow-1 is-flex is-flex-direction-column",
                        },
                        [
                          _vm.isEmail
                            ? _c(
                                "div",
                                { staticClass: "is-flex-grow-1" },
                                [
                                  _vm.isEmail && _vm.isEmailerActive
                                    ? _c("quote-email", {
                                        attrs: {
                                          quote: _vm.entity,
                                          "enable-send": true,
                                          "enable-attach": true,
                                          "reply-to-message-id":
                                            _vm.replyToMessageId,
                                          "reply-to-email": _vm.replyToEmail,
                                          "selected-attachment-email-id":
                                            _vm.selectedAttachmentEmailId,
                                          "is-incoming": _vm.isIncoming,
                                          "msg-details": _vm.msgDetails,
                                        },
                                        on: {
                                          sent: _vm.emailSent,
                                          resetEmail: _vm.resetEmail,
                                          close: _vm.closeAttachmentModel,
                                          toggleEditMaximize:
                                            _vm.toggleEditMaximize,
                                          emailDataChanged:
                                            _vm.updateEmailPreview,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "is-flex-grow-1 is-flex is-flex-direction-column is-overflow-hidden",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "is-flex-grow-1 is-flex is-flex-direction-column is-overflow-y-auto",
                                    },
                                    [
                                      _c(
                                        "article",
                                        { staticClass: "box detail-page-tile" },
                                        [
                                          _c("div", { staticClass: "field" }, [
                                            _c(
                                              "label",
                                              { staticClass: "label" },
                                              [_vm._v("To")]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "control" },
                                              [
                                                _c("phone-no-autocomplete", {
                                                  attrs: {
                                                    "quote-id":
                                                      _vm.value.quoteId,
                                                  },
                                                  on: {
                                                    select:
                                                      _vm.onPhoneNoSelected,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.msgDetails.mobile,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.msgDetails,
                                                        "mobile",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "msgDetails.mobile",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]),
                                          _c("div", { staticClass: "field" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "is-flex is-align-items-end",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "is-flex-grow-1 mr-3",
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      { staticClass: "label" },
                                                      [_vm._v("Template")]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "control is-expanded",
                                                      },
                                                      [
                                                        _c("multiselect", {
                                                          attrs: {
                                                            "track-by":
                                                              "message",
                                                            label: "message",
                                                            placeholder:
                                                              "Select Template",
                                                            options:
                                                              _vm.templates,
                                                            loading:
                                                              _vm.isTemplateLoading,
                                                            searchable: true,
                                                            "allow-empty": true,
                                                            "options-limit":
                                                              _vm.templateFilter
                                                                .pageSize,
                                                          },
                                                          on: {
                                                            select:
                                                              _vm.selectTemplate,
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "singleLabel",
                                                                fn: function ({
                                                                  option,
                                                                }) {
                                                                  return [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.truncateTemplateLabel(
                                                                            option &&
                                                                              option.message
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                },
                                                              },
                                                              {
                                                                key: "option",
                                                                fn: function ({
                                                                  option,
                                                                }) {
                                                                  return [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.truncateTemplateLabel(
                                                                            option &&
                                                                              option.message
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            false,
                                                            1970849366
                                                          ),
                                                          model: {
                                                            value:
                                                              _vm.selectedTemplate,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.selectedTemplate =
                                                                $$v
                                                            },
                                                            expression:
                                                              "selectedTemplate",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "button is-primary tooltip",
                                                    attrs: {
                                                      "data-tooltip":
                                                        "Edit message template",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.isSmsTemplateModalActive = true
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._m(3),
                                                    _c("span", [
                                                      _vm._v("Edit"),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _vm.approvedTemplate
                                            ? _c(
                                                "div",
                                                { staticClass: "field" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "control" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "is-size-7 help has-text-grey-light",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Approved Template"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        { staticClass: "box" },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.approvedTemplate
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c("div", { staticClass: "field" }, [
                                            _c(
                                              "div",
                                              { staticClass: "control" },
                                              [
                                                _c(
                                                  "label",
                                                  { staticClass: "label" },
                                                  [_vm._v("Message")]
                                                ),
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.msgDetails.message,
                                                      expression:
                                                        "msgDetails.message",
                                                    },
                                                  ],
                                                  staticClass: "textarea",
                                                  attrs: {
                                                    rows: "8",
                                                    maxlength: _vm.maxLength,
                                                    placeholder: "Text message",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.msgDetails.message,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.msgDetails,
                                                        "message",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "help",
                                                class: {
                                                  "has-text-danger":
                                                    _vm.msgDetails.message
                                                      .length >
                                                    _vm.maxLength * 0.9,
                                                  "has-text-warning":
                                                    _vm.msgDetails.message
                                                      .length >
                                                    _vm.maxLength * 0.7,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.msgDetails.message
                                                        .length
                                                    ) +
                                                    "/" +
                                                    _vm._s(_vm.maxLength) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "is-flex is-justify-content-flex-end",
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "button is-success tooltip",
                                                  attrs: {
                                                    "data-tooltip":
                                                      _vm.getToolTip(),
                                                    disabled:
                                                      _vm.isDisabledSend,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.send()
                                                    },
                                                    sent: _vm.emailSent,
                                                  },
                                                },
                                                [
                                                  _vm._m(4),
                                                  _c("span", [_vm._v("Send")]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            !_vm.editMaximize
              ? _c(
                  "div",
                  {
                    staticClass: "cell",
                    class: {
                      "is-col-span-6": _vm.isEmail && !_vm.editMaximize,
                      "is-col-span-5": !_vm.isEmail && !_vm.editMaximize,
                    },
                  },
                  [
                    _c(
                      "article",
                      {
                        staticClass:
                          "box detail-page-tile is-flex-grow-1 is-flex is-flex-direction-column",
                        staticStyle: { height: "calc(100vh - 8rem)" },
                      },
                      [
                        _c("p", { staticClass: "title" }, [
                          _vm.isEmail
                            ? _c("span", [_vm._v(" Email Log ")])
                            : _vm.isWhatsApp
                            ? _c("span", [_vm._v(" WhatsApp Log ")])
                            : _c("span", [_vm._v(" SMS Log ")]),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "message-preview is-background-white pl-2 is-flex-grow-1 is-flex is-flex-direction-column is-overflow-hidden",
                          },
                          [
                            _vm.isMessagesLoading
                              ? _c(
                                  "div",
                                  { staticClass: "has-text-centered p-4" },
                                  [
                                    _vm._m(5),
                                    _c("p", { staticClass: "mt-2" }, [
                                      _vm._v("Loading messages..."),
                                    ]),
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    ref: "messageContainer",
                                    staticClass:
                                      "is-overflow-y-auto py-2 is-flex-grow-1",
                                    staticStyle: {
                                      "scroll-behavior": "smooth",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "pr-3" },
                                      [
                                        _vm._l(
                                          _vm.messages,
                                          function (message) {
                                            return _c(
                                              "div",
                                              {
                                                key: message.id,
                                                staticClass:
                                                  "is-flex mb-4 is-full-width",
                                                class: {
                                                  "is-justify-content-flex-start":
                                                    message.isIncoming,
                                                  "is-justify-content-flex-end":
                                                    message.isOutgoing,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "message-wrapper",
                                                    style: _vm.isEmail
                                                      ? message.isIncoming
                                                        ? "width: 90%; margin-right: 10%;"
                                                        : "width: 90%; margin-left: 10%;"
                                                      : "min-width: 50%; max-width: 85%; width: auto;",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "is-flex is-justify-content-space-between is-align-items-center mb-1 px-1",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "is-size-7 has-text-weight-semibold has-text-grey",
                                                          },
                                                          [
                                                            _vm.isEmail
                                                              ? _c("span", [
                                                                  message.isIncoming
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                message.sender ||
                                                                                  "Unknown"
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                message.recipients
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                ])
                                                              : _c("span", [
                                                                  message.isIncoming
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                message.sender
                                                                                  ? _vm.formatPhoneNumber(
                                                                                      message.sender
                                                                                    )
                                                                                  : "Unknown"
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                message.recipients
                                                                                  ? _vm.formatPhoneNumber(
                                                                                      message.recipients
                                                                                    )
                                                                                  : "Unknown"
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "is-size-7 has-text-grey is-flex is-align-items-center",
                                                            staticStyle: {
                                                              gap: "2px",
                                                            },
                                                          },
                                                          [
                                                            _vm.isEmail
                                                              ? [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "material-symbols-rounded ls-size-7 has-text-weight-semibold",
                                                                      style:
                                                                        _vm.getEmailStatusIconStyle(
                                                                          message
                                                                        ),
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.getEmailStatusIconName(
                                                                            message
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "is-italic mr-1",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.getEmailStatusLabel(
                                                                            message
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              : _vm._e(),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "is-italic",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$filters.formatDateTimeLocale(
                                                                      message.createdDate,
                                                                      _vm
                                                                        .$userInfo
                                                                        .locale
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "message-bubble has-background-white p-4 mb-2 is-shadowless has-border has-radius-normal is-relative",
                                                        class: [
                                                          _vm.getMessageBubbleClass(
                                                            message
                                                          ),
                                                          {
                                                            "unread-animation":
                                                              !message.isRead,
                                                          },
                                                        ],
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "is-flex is-align-items-center is-absolute",
                                                            staticStyle: {
                                                              top: "8px",
                                                              right: "8px",
                                                              gap: "2px",
                                                              opacity: "0.7",
                                                            },
                                                          },
                                                          [
                                                            _vm.isEmail &&
                                                            message.isOutgoing
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "icon tooltip is-tooltip-right is-clickable mr-1",
                                                                    attrs: {
                                                                      "data-tooltip":
                                                                        _vm.getEmailStatus(
                                                                          message
                                                                        ),
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.openMessageModal(
                                                                            message
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "mdi mdi-16px",
                                                                      class:
                                                                        _vm.getEmailStatusIndicator(
                                                                          message
                                                                        ),
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.isEmail
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "icon tooltip is-tooltip-right is-clickable mr-1",
                                                                    attrs: {
                                                                      "data-tooltip":
                                                                        "View Email",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.viewEmail(
                                                                            message
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "mdi mdi-16px mdi-email-open",
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.isEmail
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "show",
                                                                          rawName:
                                                                            "v-show",
                                                                          value:
                                                                            message.attachments,
                                                                          expression:
                                                                            "message.attachments",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "icon tooltip is-tooltip-right is-clickable mr-1",
                                                                    attrs: {
                                                                      "data-tooltip":
                                                                        "Attachment",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.openAttachmentModel(
                                                                            message.id,
                                                                            message.isIncoming
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "mdi mdi-16px mdi-attachment",
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm.isEmail
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "icon tooltip is-tooltip-right is-clickable",
                                                                    attrs: {
                                                                      "data-tooltip":
                                                                        "Reply",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.replyTo(
                                                                            message
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "mdi mdi-16px",
                                                                      class: [
                                                                        {
                                                                          "mdi-reply-outline":
                                                                            !_vm.isSelectedReplyToMessage(
                                                                              message.messageId
                                                                            ),
                                                                        },
                                                                        {
                                                                          "mdi-reply":
                                                                            _vm.isSelectedReplyToMessage(
                                                                              message.messageId
                                                                            ),
                                                                        },
                                                                      ],
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "content is-size-6 has-text-weight-normal",
                                                          },
                                                          [
                                                            _vm.isEmail &&
                                                            message.subject
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "has-text-weight-semibold mb-1 is-size-7",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          message.subject
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "has-text-pre-wrap message-text-content",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.truncate(
                                                                      message.message,
                                                                      100
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        !_vm.isMessagesLoading &&
                                        (_vm.isEmail
                                          ? _vm.msgDetails.message.trim() ||
                                            _vm.msgDetails.emailSubject.trim() ||
                                            _vm.msgDetails.emailTo.trim()
                                          : _vm.msgDetails.message.trim() ||
                                            _vm.msgDetails.mobile)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "is-flex mb-4 is-full-width",
                                                class: {
                                                  "is-justify-content-flex-end": true,
                                                },
                                                staticStyle: { opacity: "0.6" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "message-wrapper",
                                                    style: _vm.isEmail
                                                      ? "width: 90%; margin-left: 10%;"
                                                      : "min-width: 50%; max-width: 85%; width: auto;",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "is-flex is-justify-content-space-between is-align-items-center mb-1 px-1",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "is-size-7 has-text-weight-semibold has-text-grey",
                                                          },
                                                          [
                                                            _vm.isEmail
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    " You → " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .msgDetails
                                                                          .emailTo ||
                                                                          "No recipient"
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ])
                                                              : _c("span", [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.formatPhoneNumber(
                                                                          _vm
                                                                            .msgDetails
                                                                            .mobile
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "is-size-7 has-text-grey is-flex is-align-items-center",
                                                            staticStyle: {
                                                              gap: "2px",
                                                            },
                                                          },
                                                          [
                                                            _vm.isEmail
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "material-symbols-rounded ls-size-7 has-text-weight-semibold",
                                                                    staticStyle:
                                                                      {
                                                                        color:
                                                                          "#98A6B3",
                                                                        "font-variation-settings":
                                                                          "'FILL' 1, 'wght' 600, 'GRAD' 0, 'opsz' 20",
                                                                        "font-style":
                                                                          "normal",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "drafts"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "is-italic",
                                                              },
                                                              [_vm._v("Draft")]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "message-bubble p-4 mb-2 is-shadowless has-border has-radius-normal is-relative preview-bubble",
                                                        class: [
                                                          {
                                                            "email-bubble":
                                                              _vm.isEmail,
                                                          },
                                                          _vm.getPreviewLogBubbleClass(),
                                                        ],
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "content is-size-6 has-text-weight-normal",
                                                          },
                                                          [
                                                            _vm.isEmail
                                                              ? _c("div", [
                                                                  !_vm.msgDetails.emailSubject.trim() &&
                                                                  !_vm.msgDetails.emailTo.trim() &&
                                                                  !_vm.msgDetails.message.trim()
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "has-text-centered p-2",
                                                                        },
                                                                        [
                                                                          _vm._m(
                                                                            6
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "is-size-7 is-italic",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Start composing email to show preview..."
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "email-header-preview mb-3",
                                                                            },
                                                                            [
                                                                              _vm.msgDetails.emailTo.trim()
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mb-1",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "has-text-weight-semibold is-size-7",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "To:"
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "is-size-7 ml-1",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              _vm
                                                                                                .msgDetails
                                                                                                .emailTo
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              _vm.msgDetails.emailCc.trim()
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mb-1",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "has-text-weight-semibold is-size-7",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "Cc:"
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "is-size-7 ml-1",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              _vm
                                                                                                .msgDetails
                                                                                                .emailCc
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              _vm.msgDetails.emailBcc.trim()
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mb-1",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "has-text-weight-semibold is-size-7",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "Bcc:"
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "is-size-7 ml-1",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              _vm
                                                                                                .msgDetails
                                                                                                .emailBcc
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              _vm.msgDetails.emailSubject.trim()
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mb-2",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "has-text-weight-semibold is-size-7",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "Subject:"
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "is-size-7 ml-1 has-text-weight-semibold",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              _vm
                                                                                                .msgDetails
                                                                                                .emailSubject
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                          _vm.msgDetails.emailTo.trim() ||
                                                                          _vm.msgDetails.emailSubject.trim()
                                                                            ? _c(
                                                                                "hr",
                                                                                {
                                                                                  staticClass:
                                                                                    "my-2 has-background-grey-light",
                                                                                  staticStyle:
                                                                                    {
                                                                                      height:
                                                                                        "1px",
                                                                                      "max-width":
                                                                                        "100%",
                                                                                      overflow:
                                                                                        "hidden",
                                                                                      "margin-left":
                                                                                        "0",
                                                                                      "margin-right":
                                                                                        "0",
                                                                                    },
                                                                                }
                                                                              )
                                                                            : _vm._e(),
                                                                          _vm.msgDetails.message.trim()
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "is-italic has-text-pre-wrap message-text-content",
                                                                                  staticStyle:
                                                                                    {
                                                                                      opacity:
                                                                                        "0.8",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        _vm.getProcessedMessage()
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm.msgDetails.emailTo.trim() ||
                                                                              _vm.msgDetails.emailSubject.trim()
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "has-text-centered p-2",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "is-size-7 is-italic",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Email body is empty..."
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      ),
                                                                ])
                                                              : _c("div", [
                                                                  !_vm.msgDetails.message.trim()
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "has-text-centered p-2",
                                                                        },
                                                                        [
                                                                          _vm._m(
                                                                            7
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "is-size-7 is-italic",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Start typing to show preview..."
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "is-italic has-text-pre-wrap message-text-content",
                                                                          staticStyle:
                                                                            {
                                                                              opacity:
                                                                                "0.8",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.getProcessedMessage()
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                ]),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                          ]
                        ),
                        _c(
                          "quote-email-viewer-modal",
                          {
                            attrs: {
                              active: _vm.isViewEmail,
                              "show-icon": true,
                              email: _vm.viewMessage,
                            },
                            on: {
                              "update:active": function ($event) {
                                _vm.isViewEmail = $event
                              },
                              cancel: _vm.closeViewEmail,
                              close: _vm.closeViewEmail,
                            },
                          },
                          [
                            _c(
                              "p",
                              {
                                attrs: { slot: "text-title" },
                                slot: "text-title",
                              },
                              [_vm._v("Email")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm.isSmsTemplateModalActive
              ? _c("sms-template-modal", {
                  attrs: { active: _vm.isSmsTemplateModalActive },
                  on: {
                    "update:active": function ($event) {
                      _vm.isSmsTemplateModalActive = $event
                    },
                    close: _vm.closeSmsTemplateModal,
                  },
                })
              : _vm._e(),
            _c(
              "base-modal-ex",
              {
                attrs: {
                  active: _vm.isMessageModalActive,
                  "animation-in": _vm.animationIn,
                  "animation-out": _vm.animationOut,
                  "animation-duration": _vm.animationDuration,
                  "can-cancel": false,
                  "min-width": 60,
                  "has-modal-card": "",
                },
                on: {
                  "update:active": function ($event) {
                    _vm.isMessageModalActive = $event
                  },
                },
              },
              [
                _c("header", { staticClass: "modal-card-head" }, [
                  _c(
                    "p",
                    {
                      staticClass: "modal-card-title",
                      class: { "is-flex-items-center": true },
                    },
                    [_c("span", [_vm._v("Email Delivery Failed Message")])]
                  ),
                ]),
                _c(
                  "section",
                  {
                    staticClass: "modal-card-body p-0 m-0",
                    staticStyle: { position: "relative" },
                  },
                  [
                    _c("div", { staticClass: "columns p-0 m-0" }, [
                      _c("div", { staticClass: "column p-0 m-0" }, [
                        _c("div", { staticClass: "box p-0 m-0" }, [
                          _c(
                            "div",
                            { staticClass: "columns is-multiline p-0 m-0" },
                            [
                              _c(
                                "div",
                                { staticClass: "column is-full p-3 m-0" },
                                [
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.messageModalMessage
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
                _c("footer", { staticClass: "modal-card-foot" }, [
                  _c(
                    "div",
                    {
                      style: `width: 100%; display: flex; justify-content: space-between;`,
                    },
                    [
                      _c("div", {
                        staticStyle: { "align-self": "flex-start" },
                      }),
                      _c("div", { staticStyle: { "align-self": "flex-end" } }, [
                        _c(
                          "button",
                          {
                            staticClass: "button tooltip",
                            attrs: { "data-tooltip": "Close" },
                            on: {
                              click: function ($event) {
                                return _vm.closeMessageModal()
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", {
                                staticClass: "mdi mdi-close mdi-18px",
                              }),
                            ]),
                            _c("span", [_vm._v("Close")]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "has-badge-child-offset3" }, [
      _c("span", { staticClass: "icon" }, [
        _c("i", {
          staticClass: "mdi mdi-message-text mdi-20px",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
      _c("span", {}, [_vm._v("SMS")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "has-badge-child-offset3" }, [
      _c("span", { staticClass: "icon" }, [
        _c("i", { staticClass: "mdi mdi-whatsapp mdi-20px icon-green" }),
      ]),
      _c("span", {}, [_vm._v("WhatsApp")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "has-badge-child-offset3" }, [
      _c("span", { staticClass: "icon" }, [
        _c("i", {
          staticClass: "mdi mdi-email mdi-20px",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
      _c("span", {}, [_vm._v("Email")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-pencil mdi-20px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-message-text mdi-20px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-large" }, [
      _c("i", { staticClass: "mdi mdi-loading mdi-spin mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "is-flex is-justify-content-center is-align-items-center mb-2",
        staticStyle: { gap: "4px" },
      },
      [
        _c("span", {
          staticClass: "has-background-grey is-inline-block",
          staticStyle: {
            width: "6px",
            height: "6px",
            "border-radius": "50%",
            animation: "typing-bounce 1.4s infinite ease-in-out",
            "animation-delay": "-0.32s",
          },
        }),
        _c("span", {
          staticClass: "has-background-grey is-inline-block",
          staticStyle: {
            width: "6px",
            height: "6px",
            "border-radius": "50%",
            animation: "typing-bounce 1.4s infinite ease-in-out",
            "animation-delay": "-0.16s",
          },
        }),
        _c("span", {
          staticClass: "has-background-grey is-inline-block",
          staticStyle: {
            width: "6px",
            height: "6px",
            "border-radius": "50%",
            animation: "typing-bounce 1.4s infinite ease-in-out",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "is-flex is-justify-content-center is-align-items-center mb-2",
        staticStyle: { gap: "4px" },
      },
      [
        _c("span", {
          staticClass: "has-background-grey is-inline-block",
          staticStyle: {
            width: "6px",
            height: "6px",
            "border-radius": "50%",
            animation: "typing-bounce 1.4s infinite ease-in-out",
            "animation-delay": "-0.32s",
          },
        }),
        _c("span", {
          staticClass: "has-background-grey is-inline-block",
          staticStyle: {
            width: "6px",
            height: "6px",
            "border-radius": "50%",
            animation: "typing-bounce 1.4s infinite ease-in-out",
            "animation-delay": "-0.16s",
          },
        }),
        _c("span", {
          staticClass: "has-background-grey is-inline-block",
          staticStyle: {
            width: "6px",
            height: "6px",
            "border-radius": "50%",
            animation: "typing-bounce 1.4s infinite ease-in-out",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }